unit Main;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset, TerminalForm,
  XData.Web.Dataset, XData.Web.Connection, WEBLib.DB, Vcl.Controls,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, WEBLib.EditAutocomplete,
  WEBLib.Grids, WEBLib.ExtCtrls, WEBLib.JQCtrls, WEBLib.JQGrid, Vcl.Forms,
  Vcl.Imaging.pngimage, XData.Web.Client, Client.Constants;

type
  TfrmMain = class(TForm)
    panHeader: TPanel;
    btnLogout: TButton;
    lblTitle: TLabel;
    panMain: TPanel;
    imgLogo: TImageControl;
    lblPristanisce: TLabel;
    procedure WebFormCreate(Sender: TObject);
    procedure lblTitleClick(Sender: TObject);
    procedure btnLogoutClick(Sender: TObject);
  private
    { Private declarations }
    FDarkMode: boolean;
    FLastUser: string;

    procedure ClearForm;
  public
    { Public declarations }
    frm: TTerminalForm;
    FormPrevious: string;
    FormCurrent: string;

    procedure ApplyTheme(Dark: boolean);

    procedure ShowPrevious;

    procedure ShowLogin;
    procedure ShowCheck(Txt: string);
    procedure ShowPrivez(Txt: string);
    procedure ShowScan;
    procedure ShowPristanisce;

    procedure ToggleLogoutBtn(Enabled: boolean);

    procedure ProcessLokacija;

    property DarkMode: boolean read FDarkMode write FDarkMode;
    property LastUser: string read FLastUser write FLastUser;
  protected procedure LoadDFMValues; override; end;

var
  frmMain: TfrmMain;

implementation

{$R *.dfm}

uses Login, Client.Core, Auth.Service, Check, App.Session, Foto, Privez, Pristanisce;

procedure TfrmMain.ApplyTheme(Dark: boolean);
begin
  modMain.Log('ApplyTheme main');
  if Dark then begin
    self.SetColorScheme(csDark);
    panMain.Color := $00191919;
    panMain.Font.Color := clWhite;
    panHeader.Color := $002C2C2C;
  end else begin
    self.SetColorScheme(csLight);
    panMain.Color := clWhite;
    panMain.Font.Color := clBlack;
    panHeader.Color := clBlack;
  end;
  
  if Assigned(frm) then
    frm.ApplyTheme(Dark);
end;

procedure TfrmMain.btnLogoutClick(Sender: TObject);
begin
  self.ShowLogin;
end;

procedure TfrmMain.ClearForm;
begin
  if Assigned(frm) then begin
    FormPrevious := frm.ClassName;

    modMain.Log('FormPrevious='+FormPrevious);
    frm.Close;
    frm := nil;
  end;
end;

procedure TfrmMain.ProcessLokacija;
begin
  try
//    if frm is TfrmLokacija then begin
//      TfrmLokacija(frm).ProcesirajLokacijo;
//    end;
  except
    on E:Exception do begin
      modMain.Log('(ProcessLokacija) '+E.Message);
    end;
  end;
end;

procedure TfrmMain.ShowLogin;
begin
  ClearForm;
  ToggleLogoutBtn(false);
  frm :=  TfrmLogin.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ShowPrevious;
begin
  if FormPrevious=TfrmCheck.ClassName then begin
    ShowCheck('');
  end else if FormPrevious=TfrmPristanisce.ClassName then begin
    ShowLogin;
  end else begin
    ShowLogin;
  end;
end;

procedure TfrmMain.ShowPristanisce;
  procedure AfterCreate(AForm: TObject);
  begin
//    (AForm as TfrmCheck).edtFind.Text := Txt;
  end;

begin
  ClearForm;
  frm :=  TfrmPristanisce.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.ShowPrivez(Txt: string);

  procedure AfterCreate(AForm: TObject);
  begin
    (AForm as TfrmCheck).edtFind.Text := Txt;
  end;

begin
  ClearForm;
  frm :=  TfrmPrivez.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.ShowCheck(Txt: string);

  procedure AfterCreate(AForm: TObject);
  begin
    (AForm as TfrmCheck).edtFind.Text := Txt;
  end;

begin
  ClearForm;
  frm :=  TfrmCheck.CreateNew(panMain.ElementID, @AfterCreate);
end;

procedure TfrmMain.ShowScan;
begin
  ClearForm;
  frm :=  TfrmFoto.CreateNew(panMain.ElementID, nil);
end;

procedure TfrmMain.ToggleLogoutBtn(Enabled: boolean);
begin
  btnLogout.Visible := Enabled;
  lblPristanisce.Visible := Enabled;
end;

procedure TfrmMain.WebFormCreate(Sender: TObject);
begin
  FDarkMode := StrToBoolDef(GetVar('Application.DarkMode'), false);
  FLastUser := GetVar('Application.LastName');

  imgLogo.LoadFromURL('graphics/Logo.png');

  Application.ErrorType := aeSilent;

  self.DarkMode := false;
  ApplyTheme(self.DarkMode);

  Frm := nil;
  ShowLogin;
end;

procedure TfrmMain.lblTitleClick(Sender: TObject);
begin
  FDarkMode := not FDarkMode;
  ApplyTheme(FDarkMode);
end;

procedure TfrmMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  panHeader := TPanel.Create('panHeader');
  lblTitle := TLabel.Create('lblTitle');
  imgLogo := TImageControl.Create('imgLogo');
  lblPristanisce := TLabel.Create('lblPristanisce');
  btnLogout := TButton.Create('btnLogout');
  panMain := TPanel.Create('panMain');

  panHeader.BeforeLoadDFMValues;
  lblTitle.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblPristanisce.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  panMain.BeforeLoadDFMValues;
  try
    Name := 'frmMain';
    Width := 668;
    Height := 761;
    Align := alClient;
    Caption := 'Marina.IO';
    CSSLibrary := cssBootstrap;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    Visible := True;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    panHeader.SetParentComponent(Self);
    panHeader.Name := 'panHeader';
    panHeader.Left := 0;
    panHeader.Top := 0;
    panHeader.Width := 668;
    panHeader.Height := 70;
    panHeader.Align := alTop;
    panHeader.BorderStyle := bsNone;
    panHeader.ChildOrder := 3;
    panHeader.Color := clBlack;
    panHeader.ElementPosition := epIgnore;
    panHeader.Padding.Left := 3;
    panHeader.Padding.Top := 3;
    panHeader.Padding.Right := 3;
    panHeader.Padding.Bottom := 3;
    panHeader.TabOrder := 0;
    lblTitle.SetParentComponent(panHeader);
    lblTitle.Name := 'lblTitle';
    lblTitle.AlignWithMargins := True;
    lblTitle.Left := 68;
    lblTitle.Top := 6;
    lblTitle.Width := 120;
    lblTitle.Height := 58;
    lblTitle.Margins.Left := 10;
    lblTitle.Align := alLeft;
    lblTitle.Anchors := [akLeft,akTop,akRight,akBottom];
    lblTitle.Caption := 'Marina.IO';
    lblTitle.ElementClassName := 'h2 text-light';
    lblTitle.ElementFont := efCSS;
    lblTitle.ElementPosition := epIgnore;
    lblTitle.Font.Charset := DEFAULT_CHARSET;
    lblTitle.Font.Color := clWhite;
    lblTitle.Font.Height := -27;
    lblTitle.Font.Name := 'Arial';
    lblTitle.Font.Style := [];
    lblTitle.HeightPercent := 100.000000000000000000;
    lblTitle.Layout := tlCenter;
    lblTitle.ParentFont := False;
    lblTitle.WidthPercent := 100.000000000000000000;
    imgLogo.SetParentComponent(panHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.AlignWithMargins := True;
    imgLogo.Left := 6;
    imgLogo.Top := 6;
    imgLogo.Width := 49;
    imgLogo.Height := 58;
    imgLogo.ElementClassName := 'transparent';
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Align := alLeft;
    imgLogo.ChildOrder := 5;
    imgLogo.ElementPosition := epIgnore;
    lblPristanisce.SetParentComponent(panHeader);
    lblPristanisce.Name := 'lblPristanisce';
    lblPristanisce.AlignWithMargins := True;
    lblPristanisce.Left := 201;
    lblPristanisce.Top := 6;
    lblPristanisce.Width := 12;
    lblPristanisce.Height := 13;
    lblPristanisce.Caption := '...';
    lblPristanisce.ElementFont := efCSS;
    lblPristanisce.HeightStyle := ssAuto;
    lblPristanisce.HeightPercent := 100.000000000000000000;
    lblPristanisce.Layout := tlCenter;
    lblPristanisce.WidthStyle := ssAuto;
    lblPristanisce.WidthPercent := 100.000000000000000000;
    btnLogout.SetParentComponent(panHeader);
    btnLogout.Name := 'btnLogout';
    btnLogout.Left := 602;
    btnLogout.Top := 3;
    btnLogout.Width := 63;
    btnLogout.Height := 64;
    btnLogout.Align := alRight;
    btnLogout.ElementFont := efCSS;
    btnLogout.ElementPosition := epIgnore;
    btnLogout.Font.Charset := DEFAULT_CHARSET;
    btnLogout.Font.Color := clWindowText;
    btnLogout.Font.Height := -21;
    btnLogout.Font.Name := 'Tahoma';
    btnLogout.Font.Style := [];
    btnLogout.HeightPercent := 100.000000000000000000;
    btnLogout.ParentFont := False;
    btnLogout.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogout, Self, 'OnClick', 'btnLogoutClick');
    panMain.SetParentComponent(Self);
    panMain.Name := 'panMain';
    panMain.Left := 0;
    panMain.Top := 70;
    panMain.Width := 668;
    panMain.Height := 691;
    panMain.Align := alClient;
    panMain.BorderColor := clWhite;
    panMain.BorderStyle := bsNone;
    panMain.ChildOrder := 2;
    panMain.Color := clWhite;
    panMain.ElementPosition := epIgnore;
    panMain.ShowCaption := False;
    panMain.TabOrder := 1;
  finally
    panHeader.AfterLoadDFMValues;
    lblTitle.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblPristanisce.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    panMain.AfterLoadDFMValues;
  end;
end;

end.
